var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"text-h5 justify-center wordBreak"},[_c('h2',{staticClass:"headline primary--text text--accent-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }